module.exports = __webpack_public_path__ + "static/media/personal1.cefcf415.jpg";